<template lang="html">

  <i>
    <svg width="19px" height="19px" viewBox="0 0 19 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="04a-mi-cv" transform="translate(-965.000000, -259.000000)" :fill="colors.basic" fill-rule="nonzero">
          <g id="datos-básicos" transform="translate(0.000000, 229.000000)">
            <path d="M983.219452,36.5387478 L971.22403,48.5315899 L967.094608,48.9882861 C965.897807,49.120728 964.879156,48.1114294 965.011626,46.9057515 L965.46842,42.7772178 L977.463842,30.7843757 C978.509901,29.7385414 980.20004,29.7385414 981.241532,30.7843757 L983.214884,32.7573033 C984.260943,33.8031376 984.260943,35.4974805 983.219452,36.5387478 Z M978.706323,37.949939 L976.052347,35.2965341 L967.565107,43.7865164 L967.231647,46.7687426 L970.214514,46.4353544 L978.706323,37.949939 Z M981.666351,34.3100704 L979.692999,32.3371428 C979.505713,32.1498973 979.199661,32.1498973 979.016943,32.3371428 L977.605448,33.748334 L980.259424,36.4017389 L981.670919,34.9905477 C981.853636,34.7987353 981.853636,34.4973158 981.666351,34.3100704 Z" id="Shape-Copy-4"></path>
          </g>
        </g>
      </g>
    </svg>

  </i>

</template>

<script lang="js">

  import {mapGetters} from 'vuex';

  export default  {
    name: 'edit',
    computed : {
      ...mapGetters({
      colors : 'basicColors'
    })
    }
  }
</script>

<style scoped lang="scss">
.edit {

}
</style>



// WEBPACK FOOTER //
// src/components/parts/icons/edit.vue